/* eslint-disable camelcase */
import apiUtil from 'utils/Api';
import locationUtils from 'utils/Location';

const hostsMap = {
    stag: 'https://gc-csb.zineone.com',
    prod: 'https://cloud3.zineone.com'
};

const apiKeysMap = {
    prod: Sephora.configurationSettings.sessionAIProductCountProductionAPIKey,
    stag: Sephora.configurationSettings.sessionAIProductCountStagingAPIKey
};

const getProductsCount = productId => {
    const environment = locationUtils.isProd() ? 'prod' : 'stag';
    const apiKey = apiKeysMap[environment];
    const host = hostsMap[environment];
    const msApiURL = `${host}/public/api/v1/service/fetchProductCounts?apikey=${apiKey}`;

    const options = {
        url: msApiURL,
        method: 'POST',
        params: { productId }
    };

    return new Promise(resolve => {
        apiUtil
            .request(options)
            .then(response => response.json())
            .then(data => {
                resolve(data);
            })
            .catch(_e => {
                throw new Error('SessionAI social proof no response');
            });
    });
};

export default {
    getProductsCount
};
